import { Box } from "@chakra-ui/react";
import HeroSection from "pages/home/components/HeroSection";
import About from "pages/home/components/About";
import Products from "pages/home/components/Products";
import Events from "pages/home/components/Events";
import Sponsors from "pages/home/components/Sponsors";
// import Contact from "pages/home/components/Contact";
import useMetaTags from "react-metatags-hook";

const HomePage = () => {
  useMetaTags({
    title: `GDGoC-DUT`,
    description: `Google Developer Groups on Campus - Danang University of Science and Technology`,
    charset: "utf8",
    lang: "en",
    metas: [{ name: "keywords", content: "" }],
    links: [{ rel: "canonical", href: window.location.href }],
  });
  return (
    <Box>
      <HeroSection />
      <About />
      <Events />
      <Products />
      <Sponsors />
      {/* <Contact /> */}
    </Box>
  );
};

export default HomePage;
